export default __webpack_public_path__ + "static/media-en@2x-8ae6b322f2f23ad5312d77ed2453b237.png";